module.exports = __webpack_public_path__ + "img/curve.5c7784ed.svg";